import { Col } from "react-bootstrap";
import { dataabout } from "../../content_option";

export const Intro = () => {
    return (
        <>
            <Col lg="5" className="profile_container mb-5 mt-5 d-flex justify-content-center">
                <img src={dataabout.profile} alt="profile" />
            </Col>
            <Col lg="7" className="d-flex align-items-center">
                <div className="text-justify">
                    {
                        dataabout.para.map((data, index) => {
                            return <p key={index}>{data}</p>
                        })
                    }
                </div>
            </Col>
        </>
    )
}